<template>
  <div :class="$style.anotherCases" @click="clearFilter" role="button">
    <img
      src="static/promo-static/landing-2021/src/images/blocks/customer-cases/customers/another-cases.svg"
      :class="$style.img"
      alt="Другие кейсы"
    />
    <div :class="$style.info">
      <h3 :class="$style.title">Другие кейсы</h3>
      <p :class="$style.text">Узнайте о&nbsp;других историях внедрения Хантфлоу</p>
      <span :class="$style.button">Смотреть все кейсы</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnotherCasesCard',
  methods: {
    clearFilter() {
      this.$emit('clearFilter');
    },
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.anotherCases {
  background-color: #f3f4f7;
  border-radius: 12px;
  cursor: pointer;

  @include mixins.media(md) {
    position: relative;
    border-radius: 20px;

    &::after {
      @include mixins.size(100%, calc(100% + 28px));

      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      background-color: #f3f4f7;
      border-radius: 20px;
      content: '';
    }
  }

  .img {
    max-width: 100%;
  }

  .info {
    padding: 0 24px 24px;

    @include mixins.media(md) {
      padding: 0 28px 0 28px;
    }
  }

  .title {
    @include mixins.font(2.4rem, 1.28);

    font-weight: vars.$fontWeightBase;
    letter-spacing: -0.02em;

    @include mixins.media(md) {
      @include mixins.font(2.8rem, 1.28);

      font-weight: vars.$fontWeightBase;
    }
  }

  .text {
    @include mixins.font(1.6rem, 1.45);

    margin-top: 0.4rem;
    letter-spacing: -0.005em;

    @include mixins.media(md) {
      @include mixins.font(1.8rem, 1.45);

      margin-top: 0.6rem;
      opacity: 0.8;
    }
  }

  .button {
    @include mixins.font(1.6rem, 1.55);

    display: inline-block;
    padding: 4px 12px;
    margin-top: 14px;
    background-color: vars.$colorBase;
    border-radius: 32px;
    color: #fff;

    @include mixins.hover {
      &:hover {
        background-color: #000;
      }
    }

    @include mixins.media(md) {
      margin-top: 16px;
    }
  }
}
</style>
